import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Ask({ symbol_id }) {
  const socket = useContext(SocketContext);
  const [ltp, setLtp] = useState(0);
  const [tickColor, setTickColor] = useState("text-[var(--text)]"); // default color

  useEffect(() => {
    if (!socket || !symbol_id) return;

    socket.emit("giverate", symbol_id);

    const tradeListener = (data) => {
      if (data && typeof data.LTP !== "undefined") {
        setLtp((prevLtp) => {
          const newLtp = data.LTP;

          // compare new vs old to set tick color
          if (prevLtp && newLtp > prevLtp) {
            setTickColor("text-[var(--primary)]"); // up (green)
          } else if (prevLtp && newLtp < prevLtp) {
            setTickColor("text-[var(--sell)]"); // down (red)
          }

          // reset back to default after 1s
          setTimeout(() => {
            setTickColor("text-[var(--text)]");
          }, 1000);

          return newLtp;
        });
      }
    };

    socket.on(`trade${symbol_id}`, tradeListener);

    return () => {
      socket.off(`trade${symbol_id}`, tradeListener);
    };
  }, [socket, symbol_id]);

  return <span className={`${tickColor} `}>LTP : {ltp}</span>;
}
